module.exports = __webpack_public_path__ + "static/media/Beth Tullis Headshot.cefa3680.jpg";